import { Button, Modal, Typography, message } from 'antd';
import { TFunction } from 'i18next';
import { withTranslation } from 'react-i18next';
import { useRequest } from '../../../hooks/useRequest';
import CompanyController from '../../../structures/controllers/Company';
import { IDeleteBranchCompany } from '../../../structures/interfaces/Company/Company';

const DeleteBranchCompany = ({
  t,
  visible,
  onClose,
  onConfirm,
  deleteData,
}: {
  t: TFunction;
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  deleteData: IDeleteBranchCompany;
}) => {
  const [deleteBranchCompany, isDeleteBranchCompanyRequesting] = useRequest(
    CompanyController.deleteBranchCompany
  );

  const info = () => {
    message.success({
      content: t('pages.settings.deleteBranchCompany.success.message'),
      className: 'custom-class',
      style: {
        marginTop: 60,
      },
    });
  };
  const infoError = () => {
    message.error(t('pages.settings.deleteBranchCompany.errors.message'));
  };
  const { Title } = Typography;
  const footerModal = [
    <Button
      key="back"
      danger
      onClick={onClose}
      loading={isDeleteBranchCompanyRequesting}
    >
      {t('pages.settings.deleteBranchCompany.cancelButton')}
    </Button>,
    <Button
      type="primary"
      htmlType="submit"
      onClick={() => {
        deleteBranchCompany({ id: deleteData.id })
          .then(() => {
            info();
            onConfirm();
          })
          .catch(() => {
            infoError();
          });
      }}
      loading={isDeleteBranchCompanyRequesting}
    >
      {t('pages.settings.deleteBranchCompany.confirmButton')}
    </Button>,
  ];
  return (
    <Modal width={'50%'} open={visible} onCancel={onClose} footer={footerModal}>
      <Title level={5}>{t('pages.settings.deleteBranchCompany.title')}</Title>
      <p>
        {t('pages.settings.deleteBranchCompany.info') + ' '}
        <b>{deleteData.tradeName}</b>
        {'.'}
      </p>
      <p>{t('pages.settings.deleteBranchCompany.warning')}</p>
      <p>{t('pages.settings.deleteBranchCompany.confirmMessage')}</p>
    </Modal>
  );
};

export default withTranslation()(DeleteBranchCompany);
